var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('input-dropdown', {
    attrs: {
      "qa": _vm.qa,
      "items": _vm.items,
      "value": _vm.value,
      "label": _vm.label
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }